import { Users, ShieldCheck, Wallet } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const ITEMS = [
  { icon: Users, title: "Daha Fazla Müşteri", desc: "Doğru hedefleme ile potansiyel müşterilerinize ulaşın." },
  { icon: ShieldCheck, title: "Daha Güçlü Marka", desc: "Tutarlı kreatif çalışmalarla marka bilinirliğinizi artırın." },
  { icon: Wallet, title: "Daha Verimli Bütçe", desc: "Her kuruşun karşılığını alan optimize edilmiş kampanyalar." },
];

export default function TrustStrip() {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section className="border-y border-white/5 bg-white/[0.015] py-16" data-testid="trust-strip-section">
      <div ref={ref} className={`reveal mx-auto max-w-7xl px-6 md:px-12 ${isVisible ? "is-visible" : ""}`}>
        <p className="mb-10 text-center text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
          Performans Odaklı Kreatif Reklam Çözümleri
        </p>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
          {ITEMS.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="flex flex-col items-center text-center" data-testid={`trust-item-${title.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-gold/20 bg-gold/[0.06]">
                <Icon className="h-6 w-6 text-gold-light" />
              </div>
              <h3 className="text-base font-medium text-white">{title}</h3>
              <p className="mt-1 text-sm text-slate-400">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
